import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";

import { Input, AutoSaveField as Field } from "../../../../../../components/Form";

export const SignatoryNonUAE = ({ basePath, bankIndex }) => {
  return (
    <>
      {/* <Grid item sm={6} xs={12}>
        <Field
          name={`otherBankLoanRelationship[${bankIndex}].bankName`}
          path={`${basePath}.otherBankLoanRelationship[${bankIndex}].bankName`}
          label="Name of the Lender/ Bank Name"
          placeholder="Name of the Lender/ Bank Name"
          component={Input}
          InputProps={{
            inputProps: { tabIndex: 0 }
          }}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <Field
          name={`otherBankLoanRelationship[${bankIndex}].iban`}
          path={`${basePath}.otherBankLoanRelationship[${bankIndex}].iban`}
          label="IBAN"
          placeholder="IBAN"
          component={Input}
          InputProps={{
            inputProps: { tabIndex: 0 }
          }}
        />
      </Grid>
      <Grid item sm={6} xs={12}>
        <Field
          name={`otherBankLoanRelationship[${bankIndex}].loanFacility`}
          path={`${basePath}.otherBankLoanRelationship[${bankIndex}].loanFacility`}
          label="Loan/Facility Type"
          placeholder="Loan/Facility Type"
          component={Input}
          InputProps={{
            inputProps: { tabIndex: 0 }
          }}
        />
      </Grid> */}
      <Grid item sm={6} xs={12}>
        <Field
          name={`otherBankLoanRelationship[${bankIndex}].loanAmount`}
          path={`${basePath}.otherBankLoanRelationship[${bankIndex}].loanAmount`}
          label="Finance/Facility Amount"
          placeholder="Finance/Facility Amount"
          component={Input}
          InputProps={{
            inputProps: { tabIndex: 0 }
          }}
        />
      </Grid>
      {/* <Grid item sm={6} xs={12}>
        <Field
          name={`otherBankLoanRelationship[${bankIndex}].currency`}
          path={`${basePath}.otherBankLoanRelationship[${bankIndex}].currency`}
          label="Currency"
          placeholder="Currency"
          InputProps={{
            inputProps: { tabIndex: 0 }
          }}
          component={SelectAutocomplete}
          datalistId="accountCurrencies"
        />
      </Grid> */}
    </>
  );
};

SignatoryNonUAE.propTypes = {
  /**
   * Base path for the Redux store path
   */
  basePath: PropTypes.string.isRequired,

  /**
   * Index of the bank in the banking relationships array
   */
  bankIndex: PropTypes.number.isRequired
};
